/**
 * UI Text Constants
 * Centralized location for all user-facing text, error messages, and labels
 */


// UI Text Constants
export const UI_TEXT = {
  TITLES: {
    DEFINE_AUDIENCE: 'Define Audience',
    COMPANY_INPUT_QUESTION: 'What company or product do you want to build an audience for?',
    REVIEW_RESEARCH: 'Review Research',
    REVIEW_SEGMENTS: 'Review & Refine Segments',
    REVIEW_PERSONAS: 'Review Sample Persona',
    FINALIZE_AUDIENCE: 'Name Your Audience',
    NAME_AUDIENCE_QUESTION: 'What would you like to name your audience?',
    SEGMENT_DISTRIBUTION: 'Segment Distribution',
    THANK_YOU: 'Successfully Submitted',
    AUDIENCE_CREATED: 'Perfect! Your audience is ready.',
    CREATING_AUDIENCE: 'Creating your audience...',
    PROCESSING_REQUEST: 'Processing your request...',
    STELLA: 'Stella',
    DEMOGRAPHICS: 'Demographics',
    BASIC_INFO: 'Basic Information',
    SHOPPING_PROFILE: 'Shopping Profile',
    PSYCHOGRAPHICS: 'Psychographics',
    PERSONALITY_TRAITS: 'Personality Traits (Big Five)',
    INTERESTS: 'Interests',
    GOALS: 'Goals',
    PAIN_POINTS: 'Pain Points',
    BEHAVIORS: 'Behaviors',
    VALUES: 'Values',
    MOTIVATORS: 'Motivators',
    DECISION_STYLE: 'Decision Making Style',
    BEHAVIORS_NEEDS: 'Behaviors & Needs',
    EXPECTED_OUTCOMES: 'Expected Outcomes',
    DECISION_CRITERIA: 'Decision Criteria',
    MARKETING_INSIGHTS: 'Marketing Insights',
    HUMAN_CHAOS: 'Human Chaos & Real Behavior',
    CUSTOMER_INSIGHTS: 'Customer Profile Insights',
    SEGMENT: 'Segment',
    TOTAL: 'Total',
    RESEARCH: 'Research',
    COMPETITORS: 'Competitors',
    SIMILARITIES: 'Similarities',
    DIFFERENCES: 'Differences',
    SEGMENTATION_PREFERENCES: 'Segmentation Preferences',
  },
  SUBTITLES: {
    DEFINE_TARGET_SCOPE: 'Define your simulation target and scope',
    COMPANY_INPUT_DESC: 'Share your website URL below',
    REVIEW_ANALYSIS: "Let's review our analysis and make any needed adjustments",
    REVIEW_SEGMENTS: "Let's review the customer segments identified for your audience",
    REVIEW_PERSONA: 'Give feedback on a sample persona for your audience',
    ADJUST_SEGMENTS: 'Adjust the percentage of each segment in your final audience. The total must equal 100%.',
    NAME_AUDIENCE_DESC: 'Choose a memorable name that describes your target audience',
    SUCCESS_MESSAGE: 'Your audience build request has been submitted successfully.',
    SUCCESS_MESSAGE_FREE: 'Your audience has been saved to your account and is ready to use.',
    COMPLETION_NOTICE: "We'll email you when it's ready within 24-48 hours.",
    COMPLETION_NOTICE_FREE: 'Start testing ideas with your audience',
    SEGMENTATION_DESC: 'Tell us about your preferences',
  },
  BUTTONS: {
    CONTINUE: 'Continue',
    BACK: 'Back',
    VIEW_MORE: 'View more details',
    SHOW_LESS: 'Show less',
    BUILD_AUDIENCE: 'Build My Audience',
    BACK_TO_HOME: 'Back to Home',
    START_SIMULATING: 'Simulate',
    CLOSE: 'Close',
    GO_BACK: 'Go Back',
  },
  PLACEHOLDERS: {
    COMPANY_INPUT: 'e.g., www.amazon.com or www.purina.com/dogs/dog-treats/dental-chews',
    SEGMENTS_FEEDBACK: 'Type your feedback about the segments...',
    PERSONA_FEEDBACK: 'Type your feedback about this persona...',
    RESEARCH_FEEDBACK: 'Type your feedback about the research...',
    AUDIENCE_NAME: 'E.g., Enterprise Tech Decision Makers Q3 2025',
  },
  LOADING: {
    SEGMENTS: 'Loading segments...',
    PERSONA: 'Loading persona...',
    RESEARCH: 'Loading research data...',
    AUDIENCE_DATA: 'Loading audience data...',
    REGENERATING: 'Regenerating...',
    REGENERATING_SEGMENTS: 'Regenerating segments...',
    REGENERATING_PERSONA: 'Regenerating persona...',
    REGENERATING_RESEARCH: 'Regenerating research...',
    PROCESSING: 'Processing...',
    SAVING: 'Saving...',
    SUBMITTING: 'Submitting...',
    BUILDING: 'Building...',
    TIME_ESTIMATE: 'This may take a few minutes',
  },
  PROGRESS: {
    GENERATING_PERSONAS: 'Preparing your audience data...',
    PREPARING_DATABASE: 'Preparing to save your audience...',
    SAVING_TO_DATABASE: 'Saving audience to your account...',
    ALMOST_COMPLETE: 'Almost ready...',
    CREATING_AUDIENCE: 'Creating Your Audience',
    PROGRESS_UPDATE: 'We\'ll email you when it\'s ready within 10-30 minutes.',
  },
  LABELS: {
    MARKETING_APPROACH: 'Marketing Approach:',
    KEY_CHARACTERISTICS: 'Key Characteristics:',
    CURRENT_CUSTOMERS: 'Current Customers:',
    POTENTIAL_CUSTOMERS: 'Potential Customers:',
    AGE_RANGE: 'Age Range:',
    INCOME: 'Income:',
    EDUCATION: 'Education:',
    INDUSTRY: 'Industry:',
    JOB_FUNCTION: 'Job Function:',
    ROLE_LEVEL: 'Role Level:',
    TRIGGERS_MOTIVATIONS: 'Triggers & Motivations',
    EXPECTED_OUTCOMES: 'Expected Outcomes',
    CONCERNS_OBSTACLES: 'Concerns & Obstacles',
    DECISION_CRITERIA: 'Decision Criteria',
    PATH_TO_PURCHASE: 'Path to Purchase',
    PERCENTAGE_OF_AUDIENCE: '% of audience',
    TARGET_SEGMENT: 'Target Segment',
    PRIMARY_SEGMENT: 'Primary Segment',
    PERSONAS: 'personas',
    CORE_MOTIVATION: 'Core Motivation:',
    MESSAGE_STYLE: 'Message Style:',
    TRUST_SOURCES: 'Trust Sources:',
    EMOTIONAL_TRIGGERS: 'Emotional Triggers:',
    CONTRADICTIONS: 'Contradictions:',
    REAL_LIFE_MOMENTS: 'Real Life Moments:',
    AGE: 'Age:',
    GENDER: 'Gender:',
    ROLE: 'Role:',
    INCOME_LABEL: 'Income:',
    EDUCATION_LABEL: 'Education:',
    COMPANY: 'Company:',
    TENURE: 'Tenure:',
    ANNUAL_SPEND: 'Annual Spend (USD):',
    SHOPPING_INTENSITY: 'Shopping Intensity:',
    PRIMARY_DEVICE: 'Primary Device:',
    OPENNESS: 'Openness:',
    CONSCIENTIOUSNESS: 'Conscientiousness:',
    EXTRAVERSION: 'Extraversion:',
    AGREEABLENESS: 'Agreeableness:',
    NEUROTICISM: 'Neuroticism:',
    CONCERNS_AND_OBSTACLES: 'Concerns & Obstacles:',
    TRUST_SIGNALS: 'Trust Signals:',
    BEHAVIORAL_RESISTANCE: 'Behavioral Resistance:',
    REACTION_TO_FAILURE: 'Reaction to Failure:',
    CONTRADICTION_PATTERNS: 'Contradiction Patterns:',
    REAL_MOMENTS: 'Real Moments:',
    SHOPPING_MOOD_STATES: 'Shopping Mood States:',
    LOCATION: 'Location:',
    OCCUPATION: 'Occupation:',
    JOB_TITLE: 'Job Title:',
    COGNITIVE_STYLE: 'Cognitive Style:',
  },
  FEEDBACK: {
    SHARE_GENERAL: 'Share your feedback to improve the results',
    SHARE_SEGMENTS: 'Share your feedback on these segments to improve the results',
    SHARE_PERSONA: 'Share your feedback on this persona to improve the results',
    SHARE_RESEARCH: 'Share your feedback on this research to improve the results',
    REGENERATING_SEGMENTS: "Thanks for your feedback! I'm regenerating the segments to incorporate your suggestions...",
    REGENERATING_PERSONA: "Thanks for your feedback! I'm regenerating this persona to incorporate your suggestions...",
    REGENERATING_RESEARCH: "Thanks for your feedback! I'm regenerating the research to incorporate your suggestions...",
    SUCCESS_SEGMENTS: "Perfect! I've regenerated the segments based on your feedback. The details have been updated to better match your requirements.",
    SUCCESS_PERSONA: "Perfect! I've regenerated this persona based on your feedback. The details have been updated to better match your requirements.",
    SUCCESS_RESEARCH: "Perfect! I've regenerated the research based on your feedback. The analysis has been updated to better match your requirements.",
    ERROR_SEGMENTS: "I'm sorry, there was an error regenerating the segments. Please try again or check your connection.",
    ERROR_PERSONA: "I'm sorry, there was an error regenerating the persona. Please try again or check your connection.",
    ERROR_RESEARCH: "I'm sorry, there was an error regenerating the research. Please try again or check your connection.",
  },
  SYSTEM: {
    TITLE: 'System Message',
    IMPOSSIBILITY: {
      TITLE: 'Information Unavailable',
      DEFAULT_EXPLANATION: 'This request cannot be fulfilled with the available information.',
      HELP_TEXT: 'To help me provide better results, please answer:',
    },
  },
  CONFIRMATION: {
    RESEARCH: "Please review the research above. If you'd like any changes or have additional insights, let Stella know in the chat!",
    BUSINESS_MODEL: "Please confirm the business model is correct. You can chat with Stella for feedback.",
    COMPETITORS: "Do these competitors look accurate? Copy your list of competitors in the chat to modify the details.",
    SEGMENTS: "Please review these segments. Use the chat to add additional details and regenerate the segments as needed.",
    PERSONAS: "Please review the sample persona for each segment below. Use the chat to give feedback about characteristics, goals, or any other details.",
    FINALIZE: "Please review your segment distribution above. Adjust the percentages as needed and make sure they add up to 100%.",
  },
  AUDIENCE_SCOPE: {
    QUESTION: 'Is this audience for all customers or a specific segment?',
    ALL_CUSTOMERS: 'All Customers',
    ALL_CUSTOMERS_DESC: 'Profiles will reflect your entire customer base. You can segment them later if needed.',
    SPECIFIC_SEGMENT: 'A Specific Segment',
    SPECIFIC_SEGMENT_DESC: 'e.g., "Procurement leaders in healthcare and Technology," "Gen Z buyers", etc.',
    DESCRIBE_SEGMENT: 'Describe your target segment',
    SEGMENT_PLACEHOLDER: 'E.g., Senior IT decision makers in Fortune 500 companies',
  },
  SIMULATION_TARGET: {
    QUESTION: 'What are we creating an audience for?',
    COMPANY: 'A Company',
    COMPANY_DESC: 'Simulate how people respond to a brand or organization, you can always test on a segment of the audience later',
    PRODUCT: 'A Product',
    PRODUCT_DESC: 'Simulate reactions to a specific product, feature, or service',
  },
  WEBSITE_URL: {
    COMPANY_TITLE: 'What is your company website?',
    PRODUCT_TITLE: 'What is your product page URL?',
    COMPANY_DESC: "This helps us understand your company better. We'll analyze the content to create more accurate profiles.",
    PRODUCT_DESC: "This helps us understand your product better. We'll analyze the content to create more accurate profiles.",
    COMPANY_PLACEHOLDER: 'https://yourcompany.com',
    PRODUCT_PLACEHOLDER: 'https://yourcompany.com/product',
    COMPANY_LABEL: 'Company URL',
    PRODUCT_LABEL: 'Product URL',
  },
  COMPETITORS_INPUT: {
    TITLE: 'Who are your main competitors?',
    DESCRIPTION: 'Help us understand your competitive landscape by adding competitor names you know.',
    COMPANY_LABEL: 'Company Name',
    COMPANY_PLACEHOLDER: 'e.g., Salesforce, HubSpot, Microsoft',
    ADD_BUTTON: 'Add Competitor',
    REMOVE_BUTTON: 'Remove',
    SKIP_MESSAGE: 'Please provide at least 3 competitors to continue.',
    MINIMUM_REQUIREMENT: 'Please add at least 3 competitors.',
    INVALID_NAMES: 'Please enter valid company names for all competitors.',
    EMPTY_NAMES: 'Please provide company names for all competitors or remove empty entries.',
  },
  DATA_UPLOAD: {
    HEADING: 'Do you have any customer data to share?',
    DESCRIPTION: 'Share customer info like reviews, surveys, or CRM data to build a more accurate audience.',
    UPLOAD_LABEL: 'Upload customer data',
    UPLOAD_BUTTON: 'Upload a file',
    UPLOAD_HELPER: 'CSV, Excel, or text file with customer data (max 1MB)',
    INSIGHTS_LABEL: 'Additional customer insights',
    INSIGHTS_PLACEHOLDER: 'Enter any additional information about your customers that might help us understand them better...',
  },
  QUESTIONNAIRE: {
    BUSINESS_MODEL: {
      DETECTED: 'Business Model:',
      EXPLANATION: 'We\'ll ask you specific questions based on your business model to generate more targeted segments.',
    },
    STEP1: {
      TITLE: "Tell us which customer segments you'd like us to focus on?",
      DESCRIPTION: "Which specific customer segments matter most to your business",
      PLACEHOLDER: "Examples: Moms with infants, Gen Z and Millennials, US pet owners in urban areas, CPG and D2C brands"
    },
    STEP2: {
      TITLE: "How should we group them?",
      DESCRIPTION: "Select how we should segment your audience",
      PLACEHOLDER: "Examples: By motivation, category, life-stage, demographics, industry, etc."
    },
    HELP_TEXT: {
      TIP_TITLE: 'Tip:',
      TIP_CONTENT: 'Your responses will help us generate more relevant and focused customer segments. If you do not share anything, we will create the segments that are most relevant based on your data.',
    },
  },
  AI_SURVEY: {
    FRAUD_GATE: {
      GEO: {
        TITLE: 'Access check',
        MESSAGE:
          'This survey is open to respondents in the United States only. If you are using a VPN or proxy, please disable it and try again.',
        RETRY_BUTTON: 'Try again',
        CHECKING: 'Checking your connection…',
      },
      AUTOMATION: {
        TITLE: 'Unsupported browser',
        MESSAGE:
          "This survey can't be started in this browser. Please use a standard, up-to-date web browser (Chrome, Safari, Firefox, or Edge) without automation tools.",
      },
      CHALLENGE: {
        TITLE: 'Quick verification',
        MESSAGE: 'Please confirm you are human to continue.',
        VERIFYING: 'Verifying…',
        UNAVAILABLE: 'Additional verification is required but is currently unavailable. Please try again later.',
        LOAD_ERROR: 'Verification could not be loaded. Please refresh the page and try again.',
      },
    },
    TITLES: {
      CREATE_SURVEY: 'Create AI Survey',
      BACK_TO_SURVEYS: 'Back to Surveys',
    },
    DESCRIPTIONS: {
      MAIN: 'Paste your survey questions below and our AI will parse them into an interactive conversational format.',
      SURVEY_NAME_HELP: 'Choose a name that helps you identify this survey later',
      QUESTIONS_HELP: 'Enter each question on a new line. Our AI will automatically detect question types and create appropriate input fields.',
      GOAL_HELP: 'Help our AI understand the purpose of your survey for better question parsing.',
      CONTEXT_HELP: 'Provide any additional context that might help with question parsing.',
    },
    LABELS: {
      SURVEY_NAME: 'Survey Name',
      QUESTIONS: 'Survey Questions *',
      GOAL: 'Research Goal (Optional)',
      CONTEXT: 'Additional Context (Optional)',
    },
    PLACEHOLDERS: {
      SURVEY_NAME: 'e.g., Customer Satisfaction Survey Q4 2024',
      QUESTIONS: `Paste your survey questions here, one per line. For example:

What is your overall satisfaction with our product?
Which features do you use most frequently?
How likely are you to recommend us to a friend?
What improvements would you like to see?`,
      GOAL: 'e.g., Understanding user satisfaction with our mobile app',
      CONTEXT: 'e.g., This survey is for existing customers who have used our product for at least 3 months',
    },
    BUTTONS: {
      PARSE_QUESTIONS: 'Parse Questions',
      PROCESSING: 'Processing Questions...',
      TRY_AGAIN: 'Try Again',
    },
    PROGRESS: {
      PROCESSING_TITLE: 'Processing Questions',
      PARSING_FAILED: 'Parsing Failed',
    },
    SESSION: {
      // Shown while a question's stimulus image is still loading; its answer options are
      // disabled until then, so a respondent can never rate an image they haven't seen.
      LOADING_STIMULUS: 'Loading the image — the options unlock once it appears.',
      TITLES: {
        SURVEY_SESSION: 'Survey Session',
        SURVEY_NOT_FOUND: 'Survey Not Found',
      },
      DESCRIPTIONS: {
        LOADING: 'Loading survey...',
        NOT_FOUND: 'This survey session could not be loaded.',
      },
      LABELS: {
        SESSION_ID: 'Session ID:',
        STATUS: 'Status:',
        RESPONSES: 'Responses:',
      },
      BUTTONS: {
        COMPLETE_SESSION: 'Complete Session',
        COMPLETING: 'Completing...',
        BACK_TO_SURVEYS: 'Back to Surveys',
        GO_HOME: 'Go Home',
        PREVIOUS: 'Previous',
        NEXT: 'Next',
        SUBMITTING: 'Submitting...',
        COMPLETE_SURVEY: 'Complete Survey',
      },
      MESSAGES: {
        ANALYZING_RESPONSE: [
          '🪄 Reading between the lines...',
          '🧠 Thinking deeply about your response...',
          '💭 Analyzing your thoughts...',
          '✨ Processing your answer...',
          '🎯 Understanding your perspective...',
          '🤔 Reflecting on what you shared...',
          '💡 Connecting the dots...',
          '🧩 Piecing together the puzzle...',
          '🔬 Examining your response closely...',
          '🎪 Unpacking all the details...',
          '🌊 Diving deep into your answer...',
          '🚀 Exploring your perspective...',
          '🌙 Contemplating your thoughts...',
        ],
        LISTENING: 'Listening...',
        CONVERTING_SPEECH: 'Converting speech to text...',
        TAP_TO_SPEAK: 'Tap to speak your answer',
        VOICE_CONVERTED: 'Your voice will be converted to text automatically',
        RECORDING_TAP_AGAIN: 'Recording... Tap the microphone again when finished',
        PROCESSING_SPEECH: 'Processing your speech...',
        MIC_WARMING: 'Getting your microphone ready…',
        TYPE_YOUR_ANSWER: 'Type your answer',
        YOUR_RESPONSE: 'Your response:',
        SWITCH_TO_TEXT: 'Switch to text input',
        SWITCH_TO_VOICE: 'Switch to voice input',
      },
      PLACEHOLDERS: {
        OPEN_ENDED: 'Type your answer here...',
        OTHER_SPECIFY: 'Please specify...',
      },
      CHOICES: {
        OTHER: 'Other',
      },
      ERRORS: {
        TRANSCRIPTION_EMPTY: "We couldn't hear anything in that last recording, so nothing was added. Anything recorded before it is in the box below — you can carry on typing, or switch back to the mic and try again.",
        TRANSCRIPTION_UNAVAILABLE: "Voice transcription isn't available right now, so we've switched you to typing. Your remaining answers can be typed in — sorry for the interruption.",
        ANSWER_NOT_CAPTURED: "Sorry — that answer didn't save correctly. Please enter it again.",
        MIC_NOT_READY: "We couldn't start your microphone. You can type your answer instead.",
        RECORDING_TOO_SHORT: 'That recording was too short. Please speak for at least 2 seconds.',
        RECORDING_FAILED: 'Recording failed. Please try again.',
        MIC_PERMISSION: 'Could not access microphone. Please check your permissions.',
      },
    },
    CONVERSATIONAL: {
      MIC_STOP_TITLE: 'Stop recording',
      MIC_START_TITLE: 'Hold the thought — tap to record',
      LISTENING_TAP_STOP: 'Listening… tap to stop',
      TRANSCRIBING: 'Transcribing…',
      TAP_MIC_PROMPT: 'Tap the mic and answer out loud',
      ANSWER_PLACEHOLDER: 'Your answer appears here — you can edit it before sending, or just type.',
      SENDING: 'Sending…',
      SEND_ANSWER: 'Send answer',
      ERRORS: {
        TRANSCRIBE_FAILED: 'Failed to transcribe audio. You can type your answer instead.',
      },
    },
    LIST: {
      TITLES: {
        AI_SURVEYS: 'AI Surveys',
        NO_SURVEYS: 'No surveys yet',
      },
      DESCRIPTIONS: {
        MAIN: 'Create and manage your conversational surveys',
        NO_SURVEYS: 'Create your first AI-powered survey to get started.',
      },
      BUTTONS: {
        CREATE_SURVEY: 'Create Survey',
        CREATE_FIRST_SURVEY: 'Create Your First Survey',
        VIEW_DETAILS: 'View Details',
        TAKE_SURVEY: 'Take Survey',
      },
      LABELS: {
        CREATED: 'Created',
        PUBLISHED: 'Published',
        SURVEY_NUMBER: 'Survey #',
      },
      LOADING: {
        LOADING: 'Loading surveys...',
      },
      ERRORS: {
        FAILED_TO_LOAD: 'Failed to load surveys',
      },
    },
    QUESTIONS_PREVIEW: {
      TITLES: {
        REVIEW_QUESTIONS: 'Review',
      },
      DESCRIPTIONS: {
        REVIEW_HELP: 'Review and edit the questions below. Click on any question to modify it.',
        UNSAVED_CHANGES: 'You have unsaved changes',
        QUESTIONS_COUNT: (count: number) => `${count} question${count !== 1 ? 's' : ''} parsed`,
        FOLLOWUP_INSTRUCTIONS_HELP: 'Provide specific instructions to guide the AI\'s follow-up questions',
      },
      BUTTONS: {
        SAVE: 'Save',
        CANCEL: 'Cancel',
        EDIT: 'Edit',
        ADD_CHOICE: '+ Add Choice',
        RE_ENTER_QUESTIONS: 'Re-enter Questions',
        CREATE_SURVEY: 'Create Survey',
        CREATING_SURVEY: 'Creating Survey...',
      },
      LABELS: {
        ANSWER_CHOICES: 'Answer Choices',
        QUESTION_TEXT_PLACEHOLDER: 'Enter question text',
        FOLLOWUP_INSTRUCTIONS: 'AI Follow-up Instructions',
        FOLLOWUP_INSTRUCTIONS_PLACEHOLDER: 'e.g., "If the user mentions price, ask about value for money"',
        ALLOW_OTHER_OPTION: 'Include "Other" option',
        OTHER_OPTION_INDICATOR: 'Other (with text input)',
      },
      QUESTION_TYPES: {
        OPEN_ENDED_VOICE: 'Open-Ended (Voice)',
        SINGLE_CHOICE: 'Single Choice',
        MULTIPLE_CHOICE: 'Multiple Choice',
        YES_NO: 'Yes/No',
        RATING_SCALE: 'Rating Scale',
        LIKERT_SCALE: 'Likert Scale',
        RANKING: 'Ranking',
        SHORT_TEXT: 'Short Text',
        LONG_TEXT: 'Long Text',
        DROPDOWN: 'Dropdown',
        NPS: 'Net Promoter Score',
        NUMERIC_INPUT: 'Numeric Input',
        OPEN_ENDED: 'Open-Ended',
        MATRIX_GRID: 'Matrix Grid',
        QUALITATIVE: 'Qualitative',
      },
    },
    DETAILS: {
      TITLES: {
        SURVEY: 'Survey',
        SURVEY_NOT_FOUND: 'Survey not found',
        QUESTIONS: 'Questions',
        QUICK_ACTIONS: 'Quick Actions',
        SURVEY_INFO: 'Survey Info',
        SHARE_SURVEY: 'Share Survey',
      },
      DESCRIPTIONS: {
        NO_QUESTIONS: 'No questions have been added to this survey yet.',
        SHARE_HELP: 'Copy the link below to share your survey with respondents.',
      },
      BUTTONS: {
        BACK_TO_SURVEYS: 'Back to Surveys',
        PUBLISH: 'Publish',
        PAUSE: 'Pause',
        RESUME: 'Resume',
        SHARE: 'Share',
        VIEW_LIVE: 'View Live',
        SETTINGS: 'Settings',
        EDIT_QUESTIONS: 'Edit Questions',
        PREVIEW: 'Preview',
        VIEW_ANALYTICS: 'View Analytics',
        VIEW_RESPONSES: 'View Responses',
        COPY: 'Copy',
      },
      LABELS: {
        STATUS: 'Status',
        CREATED: 'Created',
        UPDATED: 'Updated',
        PUBLISHED: 'Published',
        QUESTIONS: 'Questions',
        SESSIONS: 'Sessions',
        RESPONSES: 'Responses',
      },
      LOADING: {
        LOADING: 'Loading survey...',
      },
      ERRORS: {
        FAILED_TO_LOAD: 'Failed to load survey details',
        FAILED_TO_UPDATE: 'Failed to update survey status',
        MUST_BE_ACTIVE: 'Survey must be active to share',
      },
    },
    RESPONSES: {
      TITLES: {
        SURVEY_RESPONSES: 'Survey Responses',
        UNABLE_TO_LOAD: 'Unable to Load Responses',
        NO_RESPONSES: 'No Responses Yet',
      },
      DESCRIPTIONS: {
        VIEW_INDIVIDUAL: 'View individual responses from survey participants',
        NO_RESPONSES_YET: 'Once participants complete the survey, their responses will appear here.',
      },
      BUTTONS: {
        BACK_TO_SURVEY: 'Back to Survey',
        VIEW_DETAILS: 'View Details',
      },
      LABELS: {
        COMPLETED_RESPONSES: (count: number) => `${count} completed response${count !== 1 ? 's' : ''}`,
        RESPONSE_NUMBER: (num: number) => `Response #${num}`,
        ANSWERS: (count: number) => `${count} answer${count !== 1 ? 's' : ''}`,
      },
      LOADING: {
        LOADING_RESPONSES: 'Loading responses...',
      },
      ERRORS: {
        FAILED_TO_LOAD_RESPONSES: 'Failed to load responses. Please try again.',
      },
    },
    SESSION_RESPONSES: {
      TITLES: {
        RESPONSE_DETAILS: 'Response Details',
        UNABLE_TO_LOAD_SESSION: 'Unable to Load Session',
        NO_RESPONSES_FOUND: 'No Responses Found',
      },
      DESCRIPTIONS: {
        COMPLETED_ON: 'Completed on',
        NO_SESSION_RESPONSES: 'This session does not contain any responses.',
      },
      BUTTONS: {
        BACK_TO_RESPONSES: 'Back to Responses',
      },
      LABELS: {
        SESSION_NUMBER: (id: number) => `Session #${id}`,
        QUESTION_NUMBER: (num: number) => `Q${num}`,
        NO_RESPONSE: 'No response',
        CONDITIONALLY_SKIPPED: 'N/A - Conditionally skipped',
        AI_FOLLOWUP: 'AI Follow-up',
        USER_RESPONSE: 'Response',
        CONVERSATION: 'Conversation',
        AI_ANSWERED: 'AI-answered',
        AI_ANSWERED_TOOLTIP: 'This question was auto-answered by AI from earlier responses; the respondent did not see it.',
        AI_INFERRED_ANSWER: 'AI-inferred answer',
        AI_REASON: 'Why',
        AI_INFERRED_FROM: 'Inferred from',
        AI_CONFIDENCE: 'Confidence',
      },
      QUALITY_FLAGS: {
        RAPID_COMPLETION: 'Rapid Completion',
        VERY_SHORT_RESPONSE: 'Very Short Response',
      },
      QUALITY_DESCRIPTIONS: {
        RAPID_COMPLETION: 'Response submitted very quickly, may indicate insufficient consideration',
        VERY_SHORT_RESPONSE: 'Response contains very few characters or words',
        QUALITY_ISSUES_DETECTED: 'Quality issues detected with this response',
      },
      LOADING: {
        LOADING_SESSION: 'Loading session details...',
      },
      ERRORS: {
        FAILED_TO_LOAD_SESSION: 'Failed to load session details. Please try again.',
      },
    },
    COMPLETE: {
      TITLES: {
        THANK_YOU: 'Thank You!',
        SESSION_NOT_FOUND: 'Session Not Found',
      },
      MESSAGES: {
        SUCCESS: 'Your survey responses have been submitted successfully.',
        CLOSE_TAB: 'You can now safely close this tab or window.',
        SESSION_NOT_FOUND: 'This session could not be found.',
        LOADING: 'Loading...',
        FAILED_TO_LOAD: 'Failed to load session details.',
      },
      BUTTONS: {
        GO_HOME: 'Go Home',
      },
    },
  },
} as const;

// Utility function to get a random analyzing message
export const getRandomAnalyzingMessage = (): string => {
  const messages = UI_TEXT.AI_SURVEY.SESSION.MESSAGES.ANALYZING_RESPONSE;
  const randomIndex = Math.floor(Math.random() * messages.length);
  return messages[randomIndex];
};

// Error messages
export const ERROR_MESSAGES = {
  INVALID_URL: 'Please enter a valid website URL (e.g., google.com or https://google.com)',
  REQUIRED_FIELD: 'This field is required',
  GENERIC: 'An unexpected error occurred. Please try again.',
  RESEARCH_NOT_FOUND: 'Research data not found. Please go back and generate research first.',
  SEGMENTS_NOT_FOUND: 'Segments data not found. Please go back and generate segments first.',
  NO_SEGMENTS_AVAILABLE: 'No segments available. Please go back and define segments first.',
  NO_PERSONAS_AVAILABLE: 'No personas available',
  NO_PERSONA_ID: 'Cannot regenerate persona: No persona ID available.',
  SEGMENT_INFO_UNAVAILABLE: 'Segment information not available',
  MISSING_AUDIENCE_DATA: 'Missing required audience data. Please complete Step 1 first.',
  AUDIENCE_NAME_REQUIRED: 'Please provide a name for your audience',
  SELECT_SIMULATION_TARGET: 'Please select a simulation target',
  SELECT_AUDIENCE_SCOPE: 'Please select an audience scope',
  DESCRIBE_TARGET_SEGMENT: 'Please describe your target segment',
  GENERATE_SEGMENTS_FAILED: 'Failed to generate segments. Please try again.',
  GENERATE_PERSONAS_FAILED: 'Failed to generate personas. Please try again.',
  REGENERATE_PERSONAS_FAILED: 'Failed to regenerate personas. Please try again.',
  SAVE_SEGMENTS_FAILED: 'Failed to save segments. Please try again.',
  SAVE_PERSONAS_FAILED: 'Failed to save personas. Please try again.',
  SUBMIT_AUDIENCE_FAILED: 'Failed to submit audience request. Please try again.',
  REFRESH_RESEARCH_FAILED: 'Failed to refresh research data. Please try again.',
  REGENERATE_RESEARCH_FAILED: 'Failed to regenerate research. Please try again.',
  GENERATE_RESEARCH_FAILED: 'Failed to generate research data. Please try again.',
  SEGMENTS_PERCENTAGE_TOTAL: (totalPercentage: number) => `Segment percentages must add up to 100%. Current total: ${Math.round(totalPercentage)}%`,
  FILE_SIZE_EXCEEDED: (currentSize: number, maxSize: number) => `File size exceeds ${maxSize}MB limit. Selected file is ${currentSize.toFixed(2)}MB.`,
} as const;